import http from '@/services/api';

async function sendQuery(endpoint, query, variables = {}, updateProgress = null) {
  let onUploadProgress;
  if (updateProgress) {
    onUploadProgress = (event) => {
      const percentCompleted = Math.round((event.loaded * 100) / event.total);
      updateProgress(percentCompleted);
    };
  }

  return await http.post(
    endpoint,
    {
      query: query,
      variables: variables
    },
    { onUploadProgress }
  );
}

export const API = {
  sendQuery: sendQuery
};
